import React from 'react';
import LoadingAnimation from './LoadingAnimation';

interface LoadingStateProps {
  text?: string;
  size?: number;
  fullHeight?: boolean;
  className?: string;
}

const LoadingState: React.FC<LoadingStateProps> = ({
  text = 'Loading...',
  size = 150,
  fullHeight = true,
  className,
}) => {
  return (
    <div
      className={`flex flex-col items-center justify-center gap-2 ${fullHeight ? 'h-full min-h-[200px]' : ''} ${className ?? ''}`}
    >
      <LoadingAnimation size={size} />
      {text ? <div className="text-sm text-neutral-dark-200">{text}</div> : null}
    </div>
  );
};

export default LoadingState;
